module.exports = __webpack_public_path__ + "static/loc-174cf8b561e8324c9e86d162b2c8a7c6.jpeg";